<mat-toolbar>
  <mat-toolbar-row>
    <span>{{ 'customer.overview' | translate }}</span>
  </mat-toolbar-row>
</mat-toolbar>

<table mat-table [dataSource]="customers" class="main-content clickable-items-table" #customersTable>
  <ng-container matColumnDef="customerNr">
    <th mat-header-cell *matHeaderCellDef class="table-filter-header">
      {{ 'customer.customerNr' | translate }}
      <mat-form-field floatLabel="never">
        <input matInput [formControl]="searchForm.get('customerNr')">
      </mat-form-field>
    </th>
    <td mat-cell *matCellDef="let customer">{{ customer.customerNr }}</td>
  </ng-container>

  <ng-container matColumnDef="code">
    <th mat-header-cell *matHeaderCellDef class="table-filter-header">
      {{ 'customer.name' | translate }}
      <mat-form-field floatLabel="never">
        <input matInput [formControl]="searchForm.get('code')">
      </mat-form-field>
    </th>
    <td mat-cell *matCellDef="let customer">{{ customer.code }}</td>
  </ng-container>

  <ng-container matColumnDef="street">
    <th mat-header-cell *matHeaderCellDef class="table-filter-header">
      {{ 'customer.street' | translate }}
      <mat-form-field floatLabel="never">
        <input matInput [formControl]="searchForm.get('streetName')">
      </mat-form-field>
    </th>
    <td mat-cell *matCellDef="let customer">{{ customer.streetName }}</td>
  </ng-container>

  <ng-container matColumnDef="zipCode">
    <th mat-header-cell *matHeaderCellDef class="table-filter-header">
      {{ 'customer.zipCode' | translate }}
      <mat-form-field floatLabel="never">
        <input matInput [formControl]="searchForm.get('zipCode')">
      </mat-form-field>
    </th>
    <td mat-cell *matCellDef="let customer">{{ customer.zipCode }}</td>
  </ng-container>

  <ng-container matColumnDef="city">
    <th mat-header-cell *matHeaderCellDef class="table-filter-header">
      {{ 'customer.city' | translate }}
      <mat-form-field floatLabel="never">
        <input matInput [formControl]="searchForm.get('city')">
      </mat-form-field>
    </th>
    <td mat-cell *matCellDef="let customer">{{ customer.city }}</td>
  </ng-container>

  <ng-container matColumnDef="phone">
    <th mat-header-cell *matHeaderCellDef class="table-filter-header">
      {{ 'customer.phone' | translate }}
      <mat-form-field floatLabel="never">
        <input matInput [formControl]="searchForm.get('phone')">
      </mat-form-field>
    </th>
    <td mat-cell *matCellDef="let customer">{{ customer.phone }}</td>
  </ng-container>

  <ng-container matColumnDef="email">
    <th mat-header-cell *matHeaderCellDef class="table-filter-header">
      {{ 'customer.email' | translate }}
      <mat-form-field floatLabel="never">
        <input matInput [formControl]="searchForm.get('email')">
      </mat-form-field>
    </th>
    <td mat-cell *matCellDef="let customer">{{ customer.email }}</td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="tableColumns; sticky: true"></tr>
  <tr mat-row *matRowDef="let customer; columns: tableColumns"
    [routerLink]="['/customers', customer | objectId, 'construction_sites']"
    [class]="'linked-row'"
  ></tr>
</table>

@if (customersTable.dataSource.length == 0 ) {
  <app-no-result-message></app-no-result-message>
}

@if (actionPending$ | async) {
  <div class="spinner-container">
    <mat-spinner></mat-spinner>
  </div>
}
